import InvoicesMain from "./InvoicesMain.vue"
import SidebarWithHeader from "@/layouts/Sidebar/SidebarWithHeader.vue"
import {
	Route
} from "@/types"

export const route: Route[] = [
	{
		path: "/invoices",
		name: "Invoices",
		component: InvoicesMain,
		meta: { 
			layout: SidebarWithHeader,
			module: "invoices"
		}
	}
]

